/* 
  Extracts queries and merge them to props.
  Queries will be prioritized.
*/
export default function getQuery<T>(props: T): T {
  const q: any = {}

  if (typeof window === "undefined") {
    return props
  }
  new URLSearchParams(window.location.search).forEach((v: any, k) => {
    let parsedValue = isNaN(v) ? v : parseInt(v, 10)
    parsedValue = !isBoolean(v) ? parsedValue : stringToBool(v)
    if (k in q) {
      if (Array.isArray(q[k])) {
        q[k].push(parsedValue)
      } else {
        q[k] = [q[k], parsedValue]
      }
    } else {
      q[k] = parsedValue
    }
  })
  return { ...props, ...q }
}

const isBoolean = (val: any) => val === "true" || val == "false" || typeof val === "boolean"

const stringToBool = (val: string) => val.toLocaleLowerCase() === "true"
